import React from 'react';
import { connect } from 'react-redux';

import {db, firebase} from '../../firebase'
import {ADMIN_CHECK, AUTH_USER_SET, USER_SET} from "../../constants/ActionTypes";

const withAuthentication = (Component) => {
    class WithAuthentication extends React.Component {

        componentDidMount() {
            firebase.auth.onAuthStateChanged(authUser => {

                authUser
                    ? this.haveNewAuthUser(authUser)
                    : this.authUserNowNull();
            });
        }

        haveNewAuthUser(authUser) {
            const { onSetAuthUser, onSetIsAdmin, onSetUser } = this.props;

            onSetAuthUser(authUser);

            authUser.getIdTokenResult()
                .then((tokenResult) => {

                    onSetIsAdmin({isAdmin: !!tokenResult.claims.admin});
                })
                .catch((error) => {
                    console.warn(error);
                });

            db.getUser(authUser.uid).then(userDoc => {
                    if (!userDoc) {
                        console.warn("Could not find User in database: " + authUser.uid);
                        alert("Could not find User in database");
                    } else {
                        onSetUser(userDoc);
                    }
                }
            ).catch( error => {
                console.warn("Error on Getting user record: ", error)
            });
        }

        authUserNowNull() {

            const { onSetAuthUser, onSetUser } = this.props;

            onSetAuthUser(null);
            onSetUser(null);
        }

        render() {
            return  <Component />
        }
    }

    const mapDispatchToProps = (dispatch) => ({
        onSetAuthUser: (authUser) => dispatch({ type: AUTH_USER_SET, authUser }),
        onSetUser: (userDoc) => dispatch({ type: USER_SET, payload: userDoc }),
        onSetIsAdmin: (isAdminObj) => dispatch({ type: ADMIN_CHECK, payload: isAdminObj})
    });

    return connect(null, mapDispatchToProps)(WithAuthentication);
};

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/components/auth/withAuthentication.js